import React from 'react';
import clsx from 'clsx';

export default class OwnerDetailPresenterRooms extends React.Component {
  constructor(props) {
    super(props);
  }

  renderWeekDisplay(room) {
    const weeks = Array.from({length: 52}, (_, i) => i + 1);
    const selectedWeeks = room.weeks_owned || [];

    return (
      <div className="week-display">
        <div style={{marginBottom: '8px', fontWeight: 'bold', color: '#666'}}>
          {I18n.t('weeks_owned')}
        </div>
        <div className="week-grid" style={{display: 'grid', gridTemplateColumns: 'repeat(13, 1fr)', gap: '5px'}}>
          {weeks.map(week => (
            <div
              key={week}
              className={`week-indicator ${selectedWeeks.includes(week) ? 'selected' : 'unselected'}`}
              style={{
                padding: '2px 5px',
                fontSize: '12px',
                textAlign: 'center',
                backgroundColor: selectedWeeks.includes(week) ? '#6c757d' : '#f8f9fa',
                color: selectedWeeks.includes(week) ? '#fff' : '#666',
                border: '1px solid #dee2e6',
                borderRadius: '3px'
              }}
            >
              {week}
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderRooms() {
    if (!this.props.rooms || this.props.rooms.length === 0) {
      return (
        <div className="no-records col-md-12">
          <span className="none">{I18n.t('none')}</span>
        </div>
      )
    }

    return this.props.rooms.map((room) => (
      <div 
        className="row" 
        id={`room-${room.id}`} 
        key={`room-${room.id}`} 
        style={{
          background: "#f8f9fa",
          border: "1px solid #dee2e6",
          borderRadius: '4px',
          marginBottom: '15px',
          padding: '15px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}
      >
        <div className="col-md-12"> 
          <div style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
            <div style={{
              fontWeight: 'bold',
              color: '#495057',
              fontSize: '16px',
              borderBottom: '2px solid #e9ecef',
              paddingBottom: '8px'
            }}>
              {`${I18n.t('room_id')}: ${room.identifier}`}
            </div>
            {this.renderWeekDisplay(room)}
          </div>
        </div>
      </div>
    ))
  }

  render() {
    const tabClasses = clsx({
      'active': this.props.active_tab === 'rooms',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="rooms">
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default">
              <div className="panel-heading" style={{background: '#f8f9fa', borderBottom: '2px solid #dee2e6'}}>
                <div className="col-md-12">
                  <h3 className="panel-title" style={{color: '#495057', margin: '0'}}>
                    {I18n.t('room_ids')}
                  </h3>
                </div>
              </div>
              <div className="panel-body">
                <div className="container" style={{
                  maxHeight: '500px',
                  overflowY: 'auto',
                  padding: '15px',
                  background: '#fff',
                  borderRadius: '4px'
                }}>
                  {this.renderRooms()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

